import { memo } from 'react';

const CarouselSkeleton = memo(() => {
  return (
    <div className="flex justify-center items-center p-2 w-full" role="status" aria-label="Cargando promociones">
      <div className="w-full px-2 h-32 bg-default-100 rounded-lg animate-pulse relative overflow-hidden">
        <div className="p-4 h-full flex flex-col justify-between">
          <div className="flex-1 flex flex-col justify-center  w-8/12">
            <div className="w-48 h-8 bg-default-200 rounded mb-3 animate-pulse" />
            <div className="w-56 h-4 bg-default-200 rounded mb-4 animate-pulse" />
            <div className="w-24 h-4 bg-default-200 rounded animate-pulse" />
          </div>

          <div className="absolute right-2 top-1/2 transform -translate-y-1/2">
            <div className="w-16 h-16 bg-default-200 rounded-full animate-pulse" />
          </div>
        </div>
      </div>
    </div>
  );
});

export default CarouselSkeleton;
